const COMMON_RULES = ["active", "unit", "rotationUnit", "layer"];
const PARAMETRIC_FOOTPRINTS_RULES = [
    "package",
    "gridArrayCount",
    "gridArrayRowAlphabet",
    "gridArrayColumnAlphabet",
    "ballType",
    "pinPitch",
    "pinSize",
    "packageSize",
    "packagePlacementTolerance",
    "packageFabricationTolerance",
    "mapSilkscreenToBody",
    "padOuterMargin",
    "thermalPadSize",
];
export const footprintNodeRuleKeys = [
    ...COMMON_RULES,
    "position",
    "rotation",
    "silkColor",
    "stackup",
    ...PARAMETRIC_FOOTPRINTS_RULES,
];
export const padNodeRuleKeys = [
    ...COMMON_RULES,
    "position",
    "rotation",
    "keepOut",
    "minKeepOut",
    "maxKeepOut",
    "keepIn",
    "minKeepIn",
    "maxKeepIn",
    "size",
    "padShape",
    "cornerRadius",
    "solderPasteMaskExpansion",
    "connectedLayers",
    "scale",
];
export const layoutNodeRuleKeys = [
    ...COMMON_RULES,
    "position",
    "rotation",
    "size",
    "scale",
    "cornerRadius",
    "stackup",
    "boardColor",
    "boardShape",
    "autoLayoutGravity",
    "boardInsetMargin",
];
export const modelNodeRuleKeys = [
    ...COMMON_RULES,
    "position",
    "rotation",
    "zIsUp",
    "scale",
    "physicalMaterials",
    "showEdges",
    ...PARAMETRIC_FOOTPRINTS_RULES,
];
export const elementNodeRuleKeys = [
    ...COMMON_RULES,
    "position",
    "rotation",
    "keepOut",
    "minKeepOut",
    "maxKeepOut",
    "keepIn",
    "minKeepIn",
    "maxKeepIn",
];
export const groupNodeRuleKeys = [...COMMON_RULES, "position", "rotation"];
export const textNodeRuleKeys = [
    ...COMMON_RULES,
    "position",
    "rotation",
    "scale",
    "silkColor",
    "fontSize",
    "fontStyle",
    "textAlign",
    "content",
];
export const lineNodeRuleKeys = [
    ...COMMON_RULES,
    "position",
    "rotation",
    "scale",
    "startPosition",
    "endPosition",
    "linePath",
];
export const circleNodeRuleKeys = [...COMMON_RULES, "position", "rotation", "size", "scale"];
export const rectangleNodeRuleKeys = [
    ...COMMON_RULES,
    "startPosition",
    "endPosition",
    "position",
    "rotation",
    "scale",
    "cornerRadius",
];
export const viaNodeRuleKeys = [
    ...COMMON_RULES,
    "position",
    "keepOut",
    "minKeepOut",
    "maxKeepOut",
    "keepIn",
    "minKeepIn",
    "maxKeepIn",
    "size",
    "scale",
    "viaType",
    "connectedLayers",
    "holePosition",
];
// NOTE: "rotation" has been deliberately left out of the list of keys for smartViaNodeRuleKeys
// We use the rotation value to determine the persisted angle against which we orient the smart via children
// We don't want to bake the rotation value, and its associated rules, into the rest of the smart via rules
export const smartViaNodeRuleKeys = [
    ...COMMON_RULES,
    "position",
    "keepOut",
    "minKeepOut",
    "maxKeepOut",
    "keepIn",
    "minKeepIn",
    "maxKeepIn",
    "size",
    "scale",
    "viaOptions",
    "connectedLayers",
];
export const netNodeRuleKeys = [
    ...COMMON_RULES,
    "size",
    "keepOut",
    "minKeepOut",
    "maxKeepOut",
    "keepIn",
    "minKeepIn",
    "maxKeepIn",
    "viaType",
    "connectedLayers",
    "fillStitchingDensity",
    "fillStitchingOffset",
    "preferredTraceWidths",
    "minTraceWidth",
    "traceWidth",
    "autoLayoutPriority",
];
export const routeNodeRuleKeys = [
    ...COMMON_RULES,
    "position",
    "keepOut",
    "minKeepOut",
    "maxKeepOut",
    "keepIn",
    "minKeepIn",
    "maxKeepIn",
    "startPosition",
    "endPosition",
    "rotation",
    "size",
    "traceShape",
    "traceShapeStart",
    "traceShapeEnd",
    "traceCornerRadius",
    "traceCornerRadiusStart",
    "traceCornerRadiusEnd",
    "traceCornerRadiusMinimum",
    "preferredTraceWidths",
    "solderMaskExpansion",
    "solderMaskTopExpansion",
    "solderMaskBottomExpansion",
];
export const containerNodeRuleKeys = [...COMMON_RULES, "position", "rotation"];
export const fillNodeRuleKeys = [...COMMON_RULES, "position", "rotation"];
export const rootNodeRuleKeys = [...COMMON_RULES, "gridSpacing"];
export const zoneNodeRuleKeys = [
    ...COMMON_RULES,
    "position",
    "rotation",
    "keepOut",
    "minKeepOut",
    "maxKeepOut",
    "keepIn",
    "minKeepIn",
    "maxKeepIn",
    "size",
    "zoneShape",
    "cornerRadius",
    "connectedLayers",
    "scale",
];
export const polygonNodeRuleKeys = [
    ...COMMON_RULES,
    "position",
    "rotation",
    "keepOut",
    "minKeepOut",
    "maxKeepOut",
    "polygonShape",
    "connectedLayers",
    "minTraceWidth",
    "fillStitchingDensity",
    "fillStitchingOffset",
    "size",
    "cornerRadius",
    "protected",
];
//# sourceMappingURL=PcbNodeRuleKeys.js.map